export const removeDefaultFields = (schema, fields) => {
  return {
    ...schema,
    fieldsets: [
      {
        ...schema.fieldsets[0],
        fields: schema.fieldsets[0].fields.filter(
          (field) => !fields.includes(field),
        ),
      },
    ],
  };
};
